import { createSlice } from "@reduxjs/toolkit";
import { businessInfo } from "./thunk";
export const initialState = {
    businessInfo: {
        id: '',
        name: '',
        contact_number: '',
        address: '',
        bureau_id: '',
        user_id: '',
        status: '',
        last_activity: '',
        created_at: '',
        updated_at: ''
    },
    error: "", // for error message
    loading: false,
    isUserLogout: false,
    errorMsg: false, // for error
};

const businessInfoSlice = createSlice({
  name: "businessInfo",
  initialState,
  reducers: {
    apiError(state, action) {
      state.error = action.payload.data;
      state.loading = true;
      state.isUserLogout = false;
      state.errorMsg = true;
    },
      updateBusinessInfo(state, action) {
        state.businessInfo = { ...state.businessInfo, ...action.payload };
        state.loading = false;
        state.errorMsg = false;
    },

  },
  extraReducers: (builder) => {
    builder
      .addCase(businessInfo.pending, (state) => {
        state.loading = true;
        state.errorMsg = null;
      })
      .addCase(businessInfo.fulfilled, (state, action) => {
        console.log('Bureau data received:', action.payload);
        // Store the bureau data from the API response
        if (action.payload && action.payload.data) {
          state.businessInfo = action.payload.data;
        } else {
          state.businessInfo = action.payload;
        }
        state.loading = false;
        state.errorMsg = false;
      })
      .addCase(businessInfo.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.loading = false;
        state.errorMsg = true;
      });
  }
});

export const {
  updateBusinessInfo
} = businessInfoSlice.actions

export default businessInfoSlice.reducer;